export default function getHubspotUserToken() {
  const hubspotUserTokenObject = document.cookie
    .split(';')
    .find((row) => row.startsWith('hubspotutk='));

  if (!hubspotUserTokenObject) return undefined;

  return hubspotUserTokenObject.split('=')[1].trim();
}
